import { createSelector } from 'reselect';

const selChangeCampaignPending = state => state.companyAdmin.employeeDonations.changeCampaignPending;
const selReprocessPending      = state => state.companyAdmin.employeeDonations.reprocessPending;

const selGetPendingState = createSelector(
  [selChangeCampaignPending, selReprocessPending],
  (changeCampaignPendingMap, reprocessPendingMap) => {
    return (edId) => {
      const changeCampaign = changeCampaignPendingMap[edId] || false;
      const reprocess = reprocessPendingMap[edId] || false;
      const any = changeCampaign || reprocess;
      return {changeCampaign, reprocess, any};
    };
  }
);

export default {
  getPendingState: selGetPendingState,
};
